import { grey } from '@material-ui/core/colors';

export default () => ({
  container: { width: '100%' },
  listSubheader: {
    padding: '1rem 1rem 0',
    fontSize: '12px',
    lineHeight: '20px',
    fontWeight: '400',
  },
  highlightItem: { backgroundColor: grey[300] },
});
